/**
 * Icons with text: mobile slider (CSS transform) + dots. No overflow scroll strip.
 */
(function () {
  const mqMobile = window.matchMedia('(max-width: 749px)');

  /** @param {HTMLElement} root */
  function initRoot(root) {
    if (typeof root._iwtCleanup === 'function') root._iwtCleanup();

    const viewport = root.querySelector('[data-icons-carousel-viewport]');
    const track = root.querySelector('[data-icons-carousel-track]');
    const dotsHost = root.querySelector('[data-icons-carousel-dots]');
    if (!viewport || !track || !dotsHost) return;

    /** @returns {HTMLElement[]} */
    function getSlides() {
      return [...track.children].filter((c) => c instanceof HTMLElement);
    }

    let slides = getSlides();
    if (slides.length === 0) return;

    /** @type {HTMLButtonElement[]} */
    const dotEls = [];
    let current = 0;

    function buildDots() {
      slides = getSlides();
      dotsHost.innerHTML = '';
      dotEls.length = 0;
      const n = slides.length;
      for (let i = 0; i < n; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'icons-with-text-carousel__dot';
        btn.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + n);
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        const idx = i;
        btn.addEventListener('click', () => goTo(idx));
        dotsHost.appendChild(btn);
        dotEls.push(btn);
      }
    }

    function setDotsSelected(index) {
      dotEls.forEach((b, i) => b.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    }

    function goTo(index) {
      slides = getSlides();
      const n = slides.length;
      if (n === 0) return;
      current = Math.max(0, Math.min(index, n - 1));

      if (!mqMobile.matches) {
        track.style.transform = '';
        setDotsSelected(current);
        return;
      }

      const slide = slides[current];
      if (slide) {
        track.style.transform = 'translate3d(' + -slide.offsetLeft + 'px, 0, 0)';
      }
      setDotsSelected(current);
    }

    function onMqOrResize() {
      if (mqMobile.matches) goTo(current);
      else {
        track.style.transform = '';
        setDotsSelected(current);
      }
    }

    let resizeTick = false;
    function scheduleResize() {
      if (resizeTick) return;
      resizeTick = true;
      requestAnimationFrame(() => {
        resizeTick = false;
        onMqOrResize();
      });
    }

    buildDots();
    goTo(0);

    const SWIPE_MIN_PX = 45;
    let touchStartX = 0;
    let touchStartY = 0;

    function onTouchStart(e) {
      if (!mqMobile.matches || e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }

    function onTouchEnd(e) {
      if (!mqMobile.matches) return;
      const t = e.changedTouches[0];
      if (!t) return;
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;
      if (Math.abs(dx) < SWIPE_MIN_PX) return;
      if (Math.abs(dx) < Math.abs(dy)) return;
      e.preventDefault();
      if (dx < 0) goTo(current + 1);
      else goTo(current - 1);
    }

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchend', onTouchEnd, { passive: false });

    window.addEventListener('resize', scheduleResize);
    mqMobile.addEventListener('change', onMqOrResize);

    root.dataset.iconsCarouselReady = 'true';
    root._iwtCleanup = function () {
      track.removeEventListener('touchstart', onTouchStart);
      track.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('resize', scheduleResize);
      mqMobile.removeEventListener('change', onMqOrResize);
      track.style.transform = '';
      delete root._iwtCleanup;
      delete root.dataset.iconsCarouselReady;
    };
  }

  function initAllIn(node) {
    node.querySelectorAll('[data-icons-text-carousel]').forEach((el) => {
      if (el instanceof HTMLElement) initRoot(el);
    });
  }

  document.addEventListener('shopify:section:unload', (e) => {
    if (!(e.target instanceof HTMLElement)) return;
    e.target.querySelectorAll('[data-icons-text-carousel]').forEach((el) => {
      if (el instanceof HTMLElement && typeof el._iwtCleanup === 'function') el._iwtCleanup();
    });
  });

  document.addEventListener('shopify:section:load', (e) => {
    if (!(e.target instanceof HTMLElement)) return;
    initAllIn(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllIn(document), { once: true });
  } else {
    initAllIn(document);
  }
})();
